import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import config from 'config';
import { createAction } from '@techstyle/redux-core';
import { SearchPage } from './schema';
export var getSearchQuerySuggestionsRequest = createAction('search/getSearchQuerySuggestionsRequest');
export var getSearchQuerySuggestionsSuccess = createAction('search/getSearchQuerySuggestionsSuccess');
export var getSearchQuerySuggestionsFailure = createAction('search/getSearchQuerySuggestionsFailure');
export var getSearchQueryResultsRequest = createAction('search/getSearchQueryResultsRequest');
export var getSearchQueryResultsSuccess = createAction('search/getSearchQueryResultsSuccess');
export var getSearchQueryResultsFailure = createAction('search/getSearchQueryResultsFailure');
export function getSearchQuerySuggestions(_ref) {
  var query = _ref.query;
  var compatibilityMode = config.get('public.search.compatibilityMode');
  var searchProvider = config.get('public.search.provider'); //  Query suggestions will only be available for SS searchProvider

  if (searchProvider === 'ES') {
    throw new Error('Getting search suggestions from the ElasticSearch search provider is not possible.');
  }

  var params = {
    q: query
  };
  var apiAction;
  var requests;

  switch (compatibilityMode) {
    case 'SX':
      apiAction = 'api';
      requests = {
        types: [getSearchQuerySuggestionsRequest.toString(), {
          type: getSearchQuerySuggestionsSuccess.toString(),

          payload(action, state, res) {
            return res.json().then(payload => {
              // Rename field.
              var correctedQuery = payload['corrected-query'],
                  rest = _objectWithoutProperties(payload, ["corrected-query"]);

              return _objectSpread(_objectSpread({}, rest), {}, {
                correctedQuery
              });
            });
          }

        }, getSearchQuerySuggestionsFailure.toString()]
      };
      break;

    case 'BMIG':
      apiAction = 'bentoApi';
      requests = {
        actions: [getSearchQuerySuggestionsRequest, (payload, meta) => {
          // Rename field.
          var _payload = payload,
              correctedQuery = _payload['corrected-query'],
              rest = _objectWithoutProperties(_payload, ["corrected-query"]);

          payload = _objectSpread(_objectSpread({}, rest), {}, {
            correctedQuery
          });
          return getSearchQuerySuggestionsSuccess(payload, meta);
        }, getSearchQuerySuggestionsFailure]
      };
      break;
  }

  var action = {
    [apiAction]: _objectSpread({
      method: 'POST',
      endpoint: 'search/suggest',
      body: JSON.stringify(params)
    }, requests)
  };
  return action;
}
export function getSearchQueryResults(_ref2) {
  var aggregationFlags = _ref2.aggregationFlags,
      aggregations = _ref2.aggregations,
      backgroundFilters = _ref2.backgroundFilters,
      filters = _ref2.filters,
      page = _ref2.page,
      query = _ref2.query,
      searchType = _ref2.searchType,
      pageSize = _ref2.pageSize,
      sort = _ref2.sort,
      merchantSegmentTags = _ref2.merchantSegmentTags,
      rest = _objectWithoutProperties(_ref2, ["aggregationFlags", "aggregations", "backgroundFilters", "filters", "page", "query", "searchType", "pageSize", "sort", "merchantSegmentTags"]);

  var compatibilityMode = config.get('public.search.compatibilityMode');
  var searchProvider = config.get('public.search.provider');

  if (Array.isArray(aggregationFlags)) {
    var flags = 0;
    aggregationFlags.forEach(flag => {
      flags |= flag;
    });
    aggregationFlags = flags;
  }

  var endpoint;
  var method;
  var body;
  var searchParams;

  switch (searchProvider) {
    // What search provider to request - they accept different formats.
    case 'SS':
      endpoint = 'search/query';
      method = 'POST';
      body = {
        page,
        size: pageSize,
        sort,
        aggregations,
        backgroundFilters,
        filters,
        merchantSegmentTags,
        searchType,
        q: query
      };
      break;

    case 'ES':
      endpoint = 'search/products';
      method = 'GET';
      searchParams = _objectSpread({
        page,
        size: pageSize,
        sort,
        aggs: aggregations,
        aggFlags: aggregationFlags,
        searchTerm: query
      }, rest);
      break;
  }

  switch (compatibilityMode) {
    // What action format `dispatch()` is expecting: legacy SX vs. BMIG.
    case 'SX':
      return {
        api: {
          endpoint,
          method,
          body: JSON.stringify(body),
          params: searchParams,
          types: [getSearchQueryResultsRequest.toString(), getSearchQueryResultsSuccess.toString(), getSearchQueryResultsFailure.toString()]
        }
      };

    case 'BMIG':
      // bentoApi action
      return {
        bentoApi: {
          endpoint,
          method,
          schema: SearchPage,
          json: body,
          searchParams,
          actions: [getSearchQueryResultsRequest, getSearchQueryResultsSuccess, getSearchQueryResultsFailure]
        }
      };
  }
}